export const PLAN_MATRIX = {
  "70.3": {
    12: { light: "F1", medium: "I1", heavy: "A1" },
    16: { light: "F2", medium: "I2", heavy: "A2" },
    20: { light: "F3", medium: "I3", heavy: "A3" },
  },
  "140.6": {
    16: { light: null, medium: "F", heavy: "I" },
    20: { light: "F", medium: "I", heavy: "A" },
    24: { light: "F", medium: "I", heavy: "A" },
  },
};

export const DISTANCE_OPTIONS = [
  { value: "70.3", label: "70.3", subtitle: "Half Ironman", desc: "Bơi 1.9km – Đạp 90km – Chạy 21.1km" },
  { value: "140.6", label: "140.6", subtitle: "Full Ironman", desc: "Bơi 3.8km – Đạp 180km – Chạy 42.2km" },
];

export const LEVEL_OPTIONS = [
  { value: "finisher", label: "Finisher", desc: "Mới tập, mục tiêu hoàn thành cuộc đua" },
  { value: "intermediate", label: "Intermediate", desc: "Đã có kinh nghiệm, muốn cải thiện thành tích" },
  { value: "advanced", label: "Advanced", desc: "Nhiều kinh nghiệm, tranh giải age-group" },
];

export const DURATION_OPTIONS = {
  "70.3": [
    { value: 12, label: "12 tuần", desc: "Ngắn – Tập trung cao độ" },
    { value: 16, label: "16 tuần", desc: "Trung bình – Cân bằng tốt" },
    { value: 20, label: "20 tuần", desc: "Dài – Xây nền tảng kỹ" },
  ],
  "140.6": [
    { value: 16, label: "16 tuần", desc: "Ngắn – Yêu cầu nền tảng tốt" },
    { value: 20, label: "20 tuần", desc: "Trung bình – Phổ biến nhất" },
    { value: 24, label: "24 tuần", desc: "Dài – Đầy đủ nhất" },
  ],
};

export const INTENSITY_OPTIONS = {
  "70.3": [
    { value: "light", label: "Nhẹ", hours: "TB 7h/tuần, max 12h/tuần" },
    { value: "medium", label: "Trung bình", hours: "TB 10h/tuần, max 15h/tuần" },
    { value: "heavy", label: "Nặng", hours: "TB 13h/tuần, max 20h/tuần" },
  ],
  "140.6": [
    { value: "light", label: "Nhẹ", hours: "TB 10h/tuần, max 15h/tuần" },
    { value: "medium", label: "Trung bình", hours: "TB 13h/tuần, max 18h/tuần" },
    { value: "heavy", label: "Nặng", hours: "TB 16h/tuần, max 21h/tuần" },
  ],
};

export const SPORT_COLORS = {
  swim: { bg: "bg-sky-50", border: "border-sky-400", text: "text-sky-700", accent: "#0EA5E9", badge: "bg-sky-100 text-sky-700" },
  bike: { bg: "bg-emerald-50", border: "border-emerald-400", text: "text-emerald-700", accent: "#22C55E", badge: "bg-emerald-100 text-emerald-700" },
  run: { bg: "bg-red-50", border: "border-red-400", text: "text-red-700", accent: "#EF4444", badge: "bg-red-100 text-red-700" },
  strength: { bg: "bg-purple-50", border: "border-purple-400", text: "text-purple-700", accent: "#A855F7", badge: "bg-purple-100 text-purple-700" },
};

export const SPORT_LABELS = { swim: "Bơi", bike: "Đạp xe", run: "Chạy", strength: "Bổ trợ" };
export const SPORT_ICONS = { swim: "Waves", bike: "Bike", run: "Footprints", strength: "Dumbbell" };
export const DAY_NAMES = ["T2", "T3", "T4", "T5", "T6", "T7", "CN"];

export const MOTIVATIONAL_QUOTES = [
  "Mỗi bước chạy đều đưa bạn đến gần vạch đích hơn",
  "Không có giới hạn nào ngoài giới hạn bạn tự đặt ra",
  "Đau đớn là tạm thời, tự hào là mãi mãi",
  "Train hard, race easy",
  "Những gì không giết được bạn sẽ làm bạn mạnh hơn",
  "Hôm nay tập luyện, ngày mai chiến thắng",
  "Kỷ luật là cầu nối giữa mục tiêu và thành tựu",
  "Nỗ lực hôm nay, vinh quang ngày mai",
];
